import React from 'react';
import { get } from 'lodash';
import { BaseFieldProps, useShowContextRequired } from 'ui-builder';
import { DocumentLabel } from 'nekst-api';

export default function DocumentLabelsField(props: BaseFieldProps) {

  const showContext = useShowContextRequired();

  const labels = get(showContext.data, props.source!) as DocumentLabel[];

  return (
    <span>
      {
        labels.map((item) => item.name)
          .join(', ')
      }
    </span>
  );
}
